export default "__VITE_ASSET__Cj1c9AH___"